import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../environments/environment';
import { ForgotPasswordRequest, UserInfo, UserPasswordReset, UserProfileResponse } from './model/user';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
  observe: 'response' as 'body',
};

@Injectable({
  providedIn: 'root',
})
export class DataService {
  userInfo!: UserInfo;
  sessionTimeLeft: number = 60;

  private oktaForgotPasswordUrl: string = environment.services.oktaForgotPasswordUrl;

  constructor(private httpClient: HttpClient) {}

  validateUser(userId: string): Observable<UserProfileResponse> {
    return this.httpClient.get<UserProfileResponse>(this.oktaForgotPasswordUrl + userId, httpOptions);
  }

  passwordResetOktaUrl(body: ForgotPasswordRequest): Observable<UserPasswordReset> {
    return this.httpClient.post<UserPasswordReset>(this.oktaForgotPasswordUrl + 'forgotPassword', body);
  }
}
